import { v4 as uuidv4 } from 'uuid';

export default function useContextMenuEvent(eventPrefix: string, onOpen: (payload: any) => void, onClose: () => void) {
    const show = ref(false);
    const id = uuidv4();
    const options = ref({
        zIndex: 1000,
        minWidth: 250,
        x: 0,
        y: 0,
        scrollable: false,
        maxHeight: null,
    });

    const onUpdate = (v: boolean) => {
        if (!v) {
            hide();
        }
    };

    const hide = () => {
        show.value = false;
        onClose();
    };

    useListen(`${eventPrefix}:context-menu:open` as any, async (payload: any) => {
        console.log('open', payload);
        payload.event?.preventDefault();

        useEvent('context-menu:close' as any);

        show.value = true;

        await nextTick();
        onOpen(payload);
        await nextTick();

        const element = document.getElementById(id);
        if (!element) {
            return;
        }

        const elementHeight = element.getBoundingClientRect().height || 250;
        const elementWidth = element.getBoundingClientRect().width || 200;

        // Trouver le parent positionné (relative, absolute, ou fixed)
        let positionedParent: HTMLElement | null = element.parentElement;
        while (positionedParent) {
            const style = window.getComputedStyle(positionedParent);
            if (style.position !== 'static') {
                break;
            }
            positionedParent = positionedParent.parentElement;
        }

        // Si aucun parent positionné n'est trouvé, utiliser le body
        if (!positionedParent) {
            positionedParent = document.body;
        }

        // Obtenir la position du parent positionné par rapport au viewport
        const parentRect = positionedParent.getBoundingClientRect();

        // Calculer les coordonnées relatives au parent positionné
        // Les coordonnées viewport (x, y) moins la position du parent viewport
        let x = payload.event.x - parentRect.left;
        let y = payload.event.y - parentRect.top;

        // Ajuster pour positionner le menu juste sous le curseur
        x = x - 10;
        y = y - 10;

        // Vérifier les débordements et ajuster si nécessaire
        if (y + elementHeight > parentRect.height && y - elementHeight > 0) {
            y = y - elementHeight;
        }

        if (x + elementWidth > parentRect.width) {
            x = x - elementWidth;
        }

        options.value.x = x;
        options.value.y = y;
        options.value.scrollable = false;
        options.value.maxHeight = null;
    });

    useListen('context-menu:close' as any, () => {
        hide();
    });

    useListen(`${eventPrefix}:context-menu:close` as any, () => {
        hide();
    });

    return {
        show,
        hide,
        options,
        onUpdate,
        id,
    };
}
